import KC_IconContainer from "../../designsystem/KC_IconContainer/KC_IconContainer";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../designsystem/ds_commons";

import React, { useMemo } from "react";
import { SUPPORTED_CTAS } from "../../utils/helpers/SUPPORTED_CTAS";
import { Config, getDefaultIcon, TokenHistoryLabel } from "kadow-jetpack-model";
import getDefaultTitleForCTA from "../../utils/helpers/getDefaultTitleForCTA";
import UpsellContainer from "../../app/19_JetpackConfig/components/UpsellComponents/UpsellContainer";
import { tt } from "../../utils/i18n/i18n";
import { BASE_URL } from "../../utils/constants";

interface Props {
  config: Config | null;
  regularCTAsToDisplay: TokenHistoryLabel[];
  acquisitionCTAsToDisplay: TokenHistoryLabel[];
}

const CTAWeights: any = {
  [TokenHistoryLabel.Instagram]: 1,
  [TokenHistoryLabel.TripAdvisor]: 2,
  [TokenHistoryLabel.Receipt]: 3,
  [TokenHistoryLabel.CheckIn]: 4
};

export default function (props: Props) {
  const upsellCTAs = useMemo(() => {
    const res = Object.values(TokenHistoryLabel).filter((val) => {
      if (!SUPPORTED_CTAS.includes(val)) {
        return false;
      }

      if (val === TokenHistoryLabel.CustomForm) {
        return false;
      }

      const indexInConf =
        props.config?.ctas?.findIndex((c) => c.id === val) ?? -1;
      return (
        indexInConf === -1 &&
        !props.acquisitionCTAsToDisplay.includes(val) &&
        !props.regularCTAsToDisplay.includes(val)
      );
    });

    res.sort((a, b) => {
      const wA = CTAWeights[a] || 999;
      const wB = CTAWeights[b] || 999;
      return wA - wB;
    });

    return res;
  }, [
    props.config,
    props.acquisitionCTAsToDisplay,
    props.regularCTAsToDisplay
  ]);

  return (
    <UpsellContainer title={tt("upsell_ctas")} noGrid={true}>
      <div className="cta-upsell-container">
        {upsellCTAs.map((cta) => {
          return (
            <div
              className="p-2 border d-flex align-items-center bg-white w-100"
              style={{ borderRadius: 12 }}
            >
              <KC_IconContainer
                imgSrc={`${BASE_URL}/img/logo/${getDefaultIcon(cta)}`}
              />
              <KC_UIText
                weight={KC_Weights.md}
                text={getDefaultTitleForCTA(cta)}
              />
            </div>
          );
        })}
      </div>
    </UpsellContainer>
  );
}
